const namespace = "registrationError";

export const ALREADY_PLAYED = `${namespace}.alreadyPlayed`;
